<h2 mat-dialog-title>{{matDialogData.title}}</h2>

<mat-dialog-content>
  <iframe [src]="matDialogData.contentUrl"
          [width]="frameWidth"
          [height]="frameHeight"></iframe>
</mat-dialog-content>

<mat-dialog-actions>
  <mat-checkbox [(ngModel)]="acknowledge"
                [checked]="acknowledge">
    Don't show this message again
  </mat-checkbox>
  <button type="button"
          mat-button
          color="primary"
          (click)="onClose()">Close</button>
</mat-dialog-actions>